import React from "react";
import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import CustomDropdown from "components/CustomDropdown";
import withRoleCheck from "components/hocs/withRoleCheck";
import { invalidateSmtpAccountsQuery } from "hooks/useSmtpAccountsTable";
import _SmtpAccountModal, {
  SmtpAccountDeleteModal as _SmtpAccountDeleteModal,
} from "routes/smtp_accounts/SmtpAccountModal";

const SmtpAccountEditModal = withRoleCheck(_SmtpAccountModal, [
  ACL_RELATIONSHIPS.emailConfigSmtp.edit,
]);
const SmtpAccountDeleteModal = withRoleCheck(_SmtpAccountDeleteModal, [
  ACL_RELATIONSHIPS.emailConfigSmtp.delete,
]);

export function SmtpAccountsTableActions({ original }) {
  return (
    <CustomDropdown icon="ellipsis horizontal">
      <Dropdown.Menu direction="left">
        <SmtpAccountEditModal
          configId={original?.id}
          onSuccess={invalidateSmtpAccountsQuery}
        />
        <SmtpAccountDeleteModal
          configId={original?.id}
          onSuccess={invalidateSmtpAccountsQuery}
        />
      </Dropdown.Menu>
    </CustomDropdown>
  );
}
